/* eslint-disable no-param-reassign */
import { vuexEventPathGenerator } from '@/utils';
export const mutationType = {
    RESET_WORKER_DETAIL: 'RESET_WORKER_DETAIL',
    GET_WORKER_DETAIL: 'GET_WORKER_DETAIL',
    UPDATE_DETAIL: 'UPDATE_DETAIL',
};
export const workerEditMutationType = vuexEventPathGenerator(mutationType, 'workerManagement/workerEdit');
const mutations = {
    [mutationType.RESET_WORKER_DETAIL](state) {
        state.workerDetail = null;
    },
    [mutationType.GET_WORKER_DETAIL](state, payload) {
        state.workerDetail = payload;
    },
    [mutationType.UPDATE_DETAIL](state, payload) {
        state.workerDetail = payload;
    },
};
export default mutations;
